import api from '../../../api';
import * as endChat from '../../../modules/trader-chat/actions/end-chat';

export function request(dispatch, { chatId }) {
    api.post('/chats/' + chatId + '/end').then(
        () => dispatch(endChat.finish(chatId)),
        (data) => dispatch(endChat.error(chatId, data.errors))
    );
}

